// /components/Select/ToggleSwitch.tsx
import React from "react";

type ToggleSwitchProps = {
    label: string;
    name: string;
    checked: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const ToggleSwitch = ({ label, name, checked, onChange }: ToggleSwitchProps) => {
    return (
        <div className="flex items-center justify-between">
            <label htmlFor={name} className="font-medium">
                {label}
            </label>
            <label className="relative inline-flex items-center cursor-pointer">
                <input
                    id={name}
                    name={name}
                    type="checkbox"
                    checked={checked}
                    onChange={onChange}
                    className="sr-only peer"
                />
                <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
            </label>
        </div>
    );
};

export default ToggleSwitch;
